///---------------------------------------------------------------------------
//! Copyright (C) ASQUARED SRL - All Rights Reserved
//* Unauthorized copying of this file, via any medium is strictly prohibited
//* Proprietary and confidential
//? @author g99.alex@yahoo.com
///---------------------------------------------------------------------------

//-----------------------------------------------------------------------------------------
//* \brief
//? Front-end feature switches.
//-----------------------------------------------------------------------------------------

//-----------------------------------------------------------------------------------------
//? Card payments through NETOPIA, for everybody.
//?
//? While false, the card option is not offered: ordering a subscription and paying an
//? existing invoice both go straight to bank transfer, exactly as before card payments
//? existed. Everything else built around them - the payment result page, cancelling your
//? own unpaid order, the "waiting for payment" state on the dashboard - stays on, because
//? none of it depends on the payment method.
//?
//? To go live, BOTH switches have to be turned on and BOTH projects redeployed:
//?   1. this one                                                            (front-end)
//?   2. ACCEPT_CARD_PAYMENTS in functions/configurations/netopia_config.js  (back-end)
//?
//? The back-end one is the real gate: it refuses to open a payment even if a browser asks,
//? so a stale front-end build cannot take money before the server is ready. Turn the
//? back-end on first - the other order shows customers an option that then fails.
//-----------------------------------------------------------------------------------------
export const CARD_PAYMENTS_ENABLED = true

//-----------------------------------------------------------------------------------------
//? Accounts that get card payments even while the switch above is off.
//?
//? This exists so NETOPIA can run a real payment through the live site during their review
//? without the option being exposed to every customer while the integration is still being
//? tested. Firebase Auth UIDs, one per line.
//?
//? !!! For these accounts to actually be able to pay, ACCEPT_CARD_PAYMENTS must be TRUE on
//? !!! the back-end. The back-end has no notion of who is asking - it is a single global
//? !!! switch - so during a review the two are set differently on purpose:
//? !!!     back-end  ACCEPT_CARD_PAYMENTS  = true   (payments possible)
//? !!!     front-end CARD_PAYMENTS_ENABLED = false  (nobody is offered them)
//? !!!     front-end CARD_PAYMENT_TEST_UIDS = [ the reviewer ]
//? !!! The option is then reachable only by the accounts listed here.
//?
//? Find a UID in Firebase Console > Authentication > Users, column "User UID".
//? Remove the entries once CARD_PAYMENTS_ENABLED is turned on - they then do nothing.
//-----------------------------------------------------------------------------------------
export const CARD_PAYMENT_TEST_UIDS = [
    // 'paste the NETOPIA test account UID here',
    'YhwCfYm6z3f7xTo2nRe6k9j2bo43'
]

//-----------------------------------------------------------------------------------------
//* \brief
//? Whether this particular user may pay by card.
//-----------------------------------------------------------------------------------------
export const cardPaymentsAvailableFor = (uid) => {
    if (CARD_PAYMENTS_ENABLED) return true
    if (!uid) return false
    return CARD_PAYMENT_TEST_UIDS.includes(uid)
}
